import omitBy from 'lodash/omitBy';

export function removeEmpty(obj: object) {
  return omitBy(obj, (value) => value === null || value === '' || value === undefined);
}
